/** @module Camunda/TaskActionGroupSettingController */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/form/Widget",
	"csi/locale",
	"csi/reflection"
], function(declare,_,Widget,locale,reflection) {
	return declare(Widget, {
		/**
		 * @override
		 * Form validation , don't allow two actions under the same group has the same icon
		 */
		validateForm: function(errorParams) {
			const val = this.inherited(arguments);

			const actionCNLs = this.defView.getFieldValue("Actions");
			const actions = this.getCache().getNodes(actionCNLs);

			var iconMap = {};
			var isMutiple = _.some(actions, function(action) {
				if (!iconMap[action.Icon]) {
					iconMap[action.Icon] = action;
					return false;
				} else {
					errorParams.message = locale.resource("TaskActionGroupValidateError");
					return true;
				}
			}, this);

			return val && !isMutiple;
		},
	});
});